(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-reviews-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  const PLAYING = 'is-playing';

  const mediaOf = (el) => el.closest('[data-rv-video]');
  const videoOf = (el) => {
    const media = mediaOf(el);
    return media ? media.querySelector('video') : null;
  };

  const play = (media) => {
    const video = media.querySelector('video');
    if (!video) return;
    media.classList.add(PLAYING);
    // play() rejects when the browser blocks playback - swallow it rather
    // than throwing an unhandled rejection into the console.
    const started = video.play();
    if (started && typeof started.catch === 'function') {
      started.catch(() => media.classList.remove(PLAYING));
    }
  };

  const stop = (media) => {
    const video = media.querySelector('video');
    if (!video) return;
    media.classList.remove(PLAYING);
    video.pause();
    video.currentTime = 0;
    video.muted = true;
    const button = media.querySelector('[data-rv-sound]');
    if (button) button.setAttribute('aria-pressed', 'true');
  };

  // Hover to preview, on devices that actually have a pointer.
  const canHover = window.matchMedia('(hover: hover)').matches;

  if (canHover) {
    document.addEventListener('mouseover', (event) => {
      const media = event.target.closest && mediaOf(event.target);
      if (media && !media.contains(event.relatedTarget)) play(media);
    });

    document.addEventListener('mouseout', (event) => {
      const media = event.target.closest && mediaOf(event.target);
      if (media && !media.contains(event.relatedTarget)) stop(media);
    });
  }

  // Tap to play/pause - the only way touch users can reach these videos.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target.closest) return;

    const soundButton = target.closest('[data-rv-sound]');
    if (soundButton) {
      event.preventDefault();
      event.stopPropagation();
      const video = videoOf(soundButton);
      if (!video) return;
      video.muted = !video.muted;
      soundButton.setAttribute('aria-pressed', String(video.muted));
      if (video.paused) play(mediaOf(soundButton));
      return;
    }

    const media = mediaOf(target);
    if (!media) return;
    if (media.classList.contains(PLAYING)) {
      stop(media);
    } else {
      document.querySelectorAll('[data-rv-video].' + PLAYING).forEach(stop);
      play(media);
    }
  });

  // Stop anything still playing once it scrolls out of view.
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.target.classList.contains(PLAYING)) {
            stop(entry.target);
          }
        });
      },
      { threshold: 0 }
    );
    const observeAll = () =>
      document.querySelectorAll('[data-rv-video]').forEach((el) => observer.observe(el));
    observeAll();
    document.addEventListener('shopify:section:load', observeAll);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
